// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b93b68c9","186":"8ad8df59","344":"61f25985","372":"b619754b","443":"51479c1c","738":"526768db","787":"047065dc","841":"168db8dc","856":"b6ed47d3"}[chunkId] + ".chunk.js";
};